import { render } from "./CoreLayout.vue?vue&type=template&id=6a531f64"
import script from "./CoreLayout.vue?vue&type=script&lang=js"
export * from "./CoreLayout.vue?vue&type=script&lang=js"

import "./CoreLayout.vue?vue&type=style&index=0&id=6a531f64&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__